<template>
  <div class="login">
    <div class="background">
      <v-layout row justify-center>
        <v-flex sm4 md3 lg2 xl2 class="hidden-xs-only">
          <v-card class="form-card left-card" flat height="400px" tile>
            <v-responsive class="card-background" height="400px">
              <v-container fill-height fluid>
                <v-layout fill-height>
                  <v-flex xs12>
                    <div class="display-1 text-xs-center white--text mt-5">Bienvenido</div>
                    <div class="title text-xs-center grey--text text--lighten-2">¡Entra!</div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-responsive>
          </v-card>
        </v-flex>
        <v-flex xs12 sm5 md4 lg3 xl3>
          <v-card class="form-card right-card" flat height="400px" tile>
            <v-container fluid>
              <v-card-title primary-title>
                <div class="title login-title">Iniciar Sesión</div>
              </v-card-title>
              <v-card-text>
                <v-layout row justify-center wrap>
                  <v-flex xs12>
                    <v-text-field
                      label="Usuario"
                      v-model="username"
                      append-icon="perm_identity"
                    ></v-text-field>
                    <v-text-field
                      label="Contraseña"
                      v-model="password"
                      type="password"
                      append-icon="lock_outline"
                      @keyup.enter="signIn"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions class="mt-5 ml-2">
                <v-btn
                  outline
                  class="login-button"
                  :loading="loading"
                  @click="signIn"
                >Iniciar Sesión</v-btn>
              </v-card-actions>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12>
          <div class="body-2 text-xs-center mt-3">
            <a href="#/forgot-password" class="forgot-password-link white--text">¿Olvidaste tu contraseña?</a>
          </div>
        </v-flex>
      </v-layout>
      <v-footer class="footer pa-3" absolute>
        <div class="body-2 white--text mr-1 hidden-xs-only">Made with</div>
        <v-icon class="hidden-xs-only" dark>favorite</v-icon>
        <div class="body-2 white--text ml-1 hidden-xs-only">by</div>
        <div class="body-2 white--text ml-1">Rastreo Siglo XXI</div>
        <v-spacer></v-spacer>
        <v-icon class="mr-1" dark>copyright</v-icon>
        <div class="body-2 white--text">{{ new Date().getFullYear() }}</div>
      </v-footer>
    </div>
    <snackbar ref="snackbar"></snackbar>
  </div>
</template>

<script>
import { signIn } from '@/api/auth'

import Snackbar from '../components/Snackbar'

export default {
  name: 'login',
  data: function () {
    return {
      loading: false,
      username: '',
      password: ''
    }
  },
  components: {
    'snackbar': Snackbar
  },
  methods: {
    signIn: async function () {
      if (this.loading) {
        return false
      }
      let client
      this.loading = true
      try {
        client = await signIn({
          username: this.username,
          password: this.password
        })
      } catch (e) {
        this.loading = false
        this.username = ''
        this.password = ''
        const error = e.message
        this.$refs.snackbar.open('error', error)
        return console.error(e)
      }
      this.loading = false
      this.username = ''
      this.password = ''
      localStorage.setItem('heimdall-session-is-guest', client.isGuest)
      localStorage.setItem('heimdall-session-username', client.username)
      localStorage.setItem('heimdall-session-name', client.name)
      localStorage.setItem('heimdall-session-token', client.token)
      window.location.replace('/')
    }
  }
}
</script>

<style lang="sass" scoped>
html, body
  width: 100%
  height: 100%
.background
  width: 100%
  height: 100vh
  background-image: linear-gradient(rgba(34, 59, 75, 0.95), rgba(34, 59, 75, 0.95)), url('../assets/background-20.jpg')
  background-position: center center
  background-size: cover
.card-background
  width: 100%
  height: 100vh
  background-image: linear-gradient(rgba(220, 99, 95, 0.9), rgba(220, 99, 95, 0.9)), url('../assets/card-background-20.jpg')
  background-position: center center
  background-size: cover
.form-card
  margin-top: 20vh
.left-card
  border-radius: 5px 0px 0px 5px
.right-card
  border-radius: 0px 5px 5px 0px
.login-title
  color: rgb(220, 99, 95)
.login-button
  color: rgb(220, 99, 95)
.forgot-password-link
  text-decoration: none
.footer
  background-color: rgba(17, 41, 56, 0.3)
</style>



// WEBPACK FOOTER //
// src/views/Login.vue